import type { Messages } from '../i18n/messages';

/**
 * Notifications module message catalog (Task 7h of the Fun Mode string
 * sweep). Every static chrome string in
 * packages/app/src/modules/notifications/* is keyed here. Server/dynamic
 * data (notification titles/descriptions/links/origins from the API,
 * relative timestamps, unread/archived counts) is never keyed — it stays raw
 * or is interpolated via `{param}`.
 */
export const notificationsMessages: Messages = {
  // ---- Page header (NotificationsView.tsx) ----
  'notifications.page.title': { en: 'Notifications', fun: 'Signal Feed' },
  'notifications.page.description': {
    en: 'Alerts and updates from across your Backstage plugins.',
    fun: 'Every ping, ding, and heads-up from your plugins, in one place.',
  },
  'notifications.page.refreshTooltip': {
    en: 'Refetch notifications now.',
    fun: 'Yank the latest pings, right now.',
  },
  'notifications.page.retentionNotice': {
    en: 'Notifications are automatically removed {days} days after they arrive.',
    fun: 'Notifications get swept away {days} days after they land.',
  },

  // ---- Filters (NotificationsView.tsx) ----
  'notifications.filters.viewAriaLabel': {
    en: 'Notification view',
    fun: 'Notification view',
  },
  'notifications.filters.active': { en: 'Active', fun: 'Active' },
  'notifications.filters.archived': { en: 'Archived', fun: 'Archived' },
  'notifications.filters.readAriaLabel': {
    en: 'Notification filter',
    fun: 'Notification filter',
  },
  'notifications.filters.all': { en: 'All', fun: 'Everything' },
  'notifications.filters.unread': { en: 'Unread', fun: 'Fresh & Unread' },

  // ---- Inbox card (NotificationsView.tsx) ----
  'notifications.card.inboxTitle': { en: 'Inbox', fun: 'Inbox' },
  'notifications.card.archivedTitle': { en: 'Archived', fun: 'Vault' },
  'notifications.actions.markAllRead': {
    en: 'Mark all read',
    fun: 'Clear the whole board',
  },
  'notifications.state.loading': {
    en: 'Loading notifications…',
    fun: 'Rounding up the pings…',
  },

  // ---- Empty states (NotificationsView.tsx) ----
  'notifications.empty.all.title': {
    en: 'No notifications',
    fun: 'Nothing to see here',
  },
  'notifications.empty.all.description': {
    en: 'Notifications from your plugins will show up here.',
    fun: 'Pings from your plugins will land here the moment they fire.',
  },
  'notifications.empty.archived.title': {
    en: 'No archived notifications',
    fun: 'The vault is empty',
  },
  'notifications.empty.archived.description': {
    en: 'Notifications you archive will show up here.',
    fun: 'Stash a notification and it will turn up here.',
  },
  'notifications.empty.unread.title': {
    en: 'No unread notifications',
    fun: 'Inbox zero, achieved',
  },
  'notifications.empty.unread.description': {
    en: 'You are all caught up.',
    fun: 'You are all caught up — go be a legend elsewhere.',
  },

  // ---- Row actions (NotificationsView.tsx) ----
  'notifications.actions.unarchive': {
    en: 'Unarchive',
    fun: 'Bring it back',
  },
  'notifications.actions.markUnread': {
    en: 'Mark unread',
    fun: 'Mark unread',
  },
  'notifications.actions.markRead': { en: 'Mark read', fun: 'Mark read' },
  'notifications.actions.archive': { en: 'Archive', fun: 'Stash it' },
};
